export default async function loginUser(username, password) {
  const loginForm = new FormData();
  loginForm.append('username', username);
  loginForm.append('password', password);
  return fetch(`${process.env.REACT_APP_HELDR_API_URL}/token`, {
    method: 'POST',
    body: loginForm,
  });
}
